module.exports = __webpack_public_path__ + "img/Impacts to ESS-Impact interaction.9fc0d8c1.svg";